//由于ts 无法直接引入这个 所以先用js引入，然后再用js引入
import nprogress from 'nprogress'
import "nprogress/nprogress.css"
export default nprogress